const doc = [({"da":({"js":({"admin":({"highscores":({"index":({"the_highscore_was_deleted":"Highscoren blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;